import { render, staticRenderFns } from "./MessageAccordion.vue?vue&type=template&id=5a8c5c35&lang=pug"
import script from "./MessageAccordion.vue?vue&type=script&lang=ts"
export * from "./MessageAccordion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports